import { getUsers } from "@/api/users.service";

export const useUserSearch = () => {
  return {
    itemTitle: i => i.email,
    comparisonValue: v => v.id,
    fetchResults: async (search, searchArgs, cancelToken) => {
      const res = await getUsers({ email: search }, cancelToken);
      return res?.items || [];
    }
  };
};
